
(function (global) {

  var pleaseWaitMessage = {
    _topSpinner: null,
    _pleaseWaitText: $('#SignPleaseWait'),
    _pleaseWaitCounter: 0,
    show: function () {
      this._topSpinner = WA.CR.spinner.show();
      this._pleaseWaitText.show();
      this._pleaseWaitCounter += 1;
    },
    hide: function () {
      this._pleaseWaitCounter -= 1;
      if (this._pleaseWaitCounter === 0) {
        this._topSpinner.hide();
        this._pleaseWaitText.hide();
      }
    }
  };

  /**
  * Показывает диалог подписания документа.  
  * @global
  * @param {number} id ИД подписываемого документа.
  * @param {number} [versionNumber] номер подписываемой версии документа.
  * @param {boolean} [isSignCustomwork = false] TRUE если подписание объекта ЗЗУ, иначе FAlSE.
  * @param {string} objectType тип объекта (для ЗЗУ)
  */
  global.SignEDoc = (id, versionNumber, isSignCustomwork = false, objectType) => {
    if (WA.agent.checkAvailability()) {
      id = id || GetParamInURL('id');

      Core.agent.getPlugin('CryptographyPlugin').done(plugin => {
        ShowModalWindow('sign', {
          title: L('EDOCUMENT_SIGN'),
          afterOpen: () => {
            BindHelpIcoClickOnModalWindow('Sign');
            const jModalWnd = $('#modal_window');

            // Если подписание невозможно, то в модальном окне не инициализируются контролы для выбора сертификата,
            //а только сообщение об ошибке
            const isControlsInited = jModalWnd.find('#sign_certificate').length;
            if (isControlsInited) {
              //если подписание возможно, то докручиваем контролы модалки
              if (versionNumber) {
                jModalWnd.find(`input[type=radio][value=${versionNumber}]`).click();
              }
              key.setScope('baseDialog');

              const jTokenPinMessage = jModalWnd.find('#new_error_container');
              const jTokenPinInput = jModalWnd.find('.token_pin_code');

              if (jTokenPinMessage.length) {
                // Обернуть сообщение и поле ввода для пин-кода нельзя ввиду особенностей рендера диалога.
                jTokenPinMessage.parent().hide();
                jTokenPinInput.parent().parent().hide();
              }
            } else {
              // Скрываем кнопку Canсel и оставляем активной ОК, если в далоге отображается только сообщение об ошибке
              jModalWnd.data('enable_ok')();
              jModalWnd.next().find('[data-name="CancelButton"]').hide();
            }
          },
          ok: () => {
            // Дизейблим ок, чтобы пользователь не "ускорял процесс подписания".
            const jWindow = $('#modal_window');
            const disableFunction = jWindow.data('disable_ok');
            if (typeof disableFunction === 'function' || disableFunction instanceof Function) {
              disableFunction();
            }
            const handler = jWindow.data('ok');           
            if (handler && (typeof handler === 'function' || handler instanceof Function)) {
              return handler();            
            }
          },
          cancel: () => {
            const handler = $('#modal_window').data('cancel');            
            if (handler && (typeof handler === 'function' || handler instanceof Function)) {
              return handler();            
            }         
          },
          params: {
            EDocID: id,
            IsSignCustomwork: isSignCustomwork,
            ObjectType: objectType,
            UseAgent: true,
          },
          height: 'auto',
          drag: () => { $('#modal_window').parent().css('height', 'auto'); },
          close: () => {
            const handler = $('#modal_window').data('close');
            clearAllModalDivs();
            if (handler) return handler();
          },
          position: [
            'center',
            (windowHeight() / 2) - 200,
          ],
        });
      }).fail(needShowError => {
        if (needShowError) {
          ShowError(L('ERR_SIGNING_UNSUPPORTED'));
        }
      });
    }
  };

  /**
  * Инициализирует контроли для диалога окна подписания документа.  
  * @global
  * @param {Array<integer>} documentId ИД подписываемого документа или массив ИД документов.
  * @param {string} cardTypeCode тип карточки документа.
  * @param {boolean} isMultiple TRUE если множественное подписание, иначе - FALSE.
  * @param {boolean} isSignCustomwork TRUE если подписание объекта ЗЗУ, иначе - FALSE.
  * @param {string} ObjType тип объекта (для ЗЗУ).
  * @param {Array<integer>} taskIds ид задач для множественного подписания.
  * @param {Array<integer>} jobIds ид заданий для множественного подписания.
  * @param {Array<string>} taskNames темы задач для множественного подписания.
  * @param {Array<string>} jobNames темы заданий для множественного подписания.
  */
  global.SignEDoc_InitControls = function (documentId, cardTypeCode, isMultiple, isSignCustomwork, ObjType, taskIds, jobIds, taskNames, jobNames) {

    const jModalWindow = $('#modal_window');    
    let verData = {};
    let certData = {};
    let addInfo = {};

    // Сохраняем функцию в data, чтобы был доступ к ней в глобальной области видимости (нужно для контролей реквизитов)
    jModalWindow.data('checkConditions', () => {
      checkConditions(jModalWindow, certData, verData, addInfo);
    });
    jModalWindow.data('certSelect', () => {
      certSelect(jModalWindow, certData, verData, addInfo);
    });

    // Событие нажатия на чекбокс "подписать за".
    jModalWindow.find('#sign_substitute').change((event) => {  
      if ($(event.target).is(':checked')) {

        // Загружаем коды пользователей, за которых можно подписать.
        pleaseWaitMessage.show();

        let versionNumber = getSelectedVersionNumber(jModalWindow);
        getSubstitutedUserCodes(
         jModalWindow,
         documentId,
         isMultiple,
         verData,
         versionNumber).always(users => {
           const curUserCodes = (verData[versionNumber]) ? verData[versionNumber][getIsApproving(jModalWindow) ? 'app' : 'vis'] : users;
           if (curUserCodes && curUserCodes.length && curUserCodes !== 'loading') {
             $('#sign_user').SetEnabled();
             //При изменении замещаемого пользователя.
             $('#sign_user').change(function () {
               checkConditions(jModalWindow, certData, verData, addInfo);
             });

             if (isMultiple) {
               jModalWindow.data('enable_ok')();
               setAllowedUserCodes(jModalWindow, curUserCodes);
             } else {
               checkConditions(jModalWindow, certData, verData, addInfo);
             }
           } else {
             jModalWindow.data('error')(L('YOU_CANT_SIGN_THIS_DOCUMENT_IN_THE_NAME_OF_SUBSTITUTED_USER_INLINE'));
             jModalWindow.data('disable_ok')();
           }
           pleaseWaitMessage.hide();
         });

      } else {
        $('#sign_user').SetDisabled();
        checkConditions(jModalWindow, certData, verData, addInfo);
      }
    });

    // Событие нажатия на чекбокс "утверждающая подпись".
    jModalWindow.find('#sign_approving').change(() => {
      let versionNumber = getSelectedVersionNumber(jModalWindow);
      if (getIsSubstitute(jModalWindow)) {
        pleaseWaitMessage.show();
        getSubstitutedUserCodes(
         jModalWindow,
         documentId,
         isMultiple,
         verData,
         versionNumber).always(() => {
           checkConditions(jModalWindow, certData, verData, addInfo);
           pleaseWaitMessage.hide();
         });
      } else {
        checkConditions(jModalWindow, certData, verData, addInfo);
      }
    });

    // Событие выбора версии.
    jModalWindow.find('input[type="radio"]').change((event) => {
      const jVersionSelect = $(event.target);
      if (jVersionSelect.is(':checked')) {
        verSelect(jModalWindow, documentId, isMultiple, certData, verData, jVersionSelect.val(), addInfo);
      }
    }).change(); // изначально версия выбрана.

    certSelect(jModalWindow, certData, verData, addInfo); // запускаем проверку сертификата.

    // При нажатии на кнопку ОК - подписываем документ.
    jModalWindow.data('ok', opt_customWorkSignResults => {
      // Сохраняем выбранный тип подписи в профиле пользователя
      saveDialogParams(jModalWindow);

      /**
      * Подписание множества документов
      */
      if (isMultiple) {
        const signMultiple = function (signResults) {
          $.whenAllDone(...signResults).then(() => {
            UnlockDocIfNeed(jModalWindow, documentId, isMultiple);
            jModalWindow.dialog('close');
            (new WA.CMP.NTF.Toast).show(L('MULTIPLE_SIGN_COMFIRMATION'));
            jModalWindow.remove();
          }).fail((...args) => {
            // ToDo: данный хак предназначен для кейса, когда во вложении выбирается один документ и вызывается окно
            // подписания. Считается, что документов было несколько, поэтому выводится окно подписания множества
            // документов. Эта функция не была готова к такому повороту событий. Можно будет убрать, когда исправят
            // пожелание, чтобы отображалось окно подписания документа.
            if (args.length === 1) {
              args[0] = args[0][0];
            }
            jModalWindow.dialog('close');
            jModalWindow.remove();

            const dialog = new WA.CMP.dialogs.MessageBox({ width: 600 });
            const details = new WA.CMP.forms.FormBuilder('signingDetails');
            details.setOrientation(ORIENTATION.VERTICAL);
            details.addTextFrame('NOT_ALL_OBJECTS_SIGNED_INFORMATION_MESSAGE', `<ul>${args.join('')}</ul>`);

            details.renderAsync().done(data => {
              dialog.showError(L('MULTIPLE_SIGN_SUCCESS_WITH_ERROR'), data);
            });
          });
        };

        if (isSignCustomwork) {
          let signResults = [];
          for (let taskId in taskIds) {
            signResults.push(sign(jModalWindow, taskIds[taskId], null, null, taskNames[taskId], true, true, 'T'));
          }
          for (let jobId in jobIds) {
            signResults.push(sign(jModalWindow, jobIds[jobId], null, null, jobNames[jobId], true, true, 'J'));
          }
          if (opt_customWorkSignResults) {
            signResults = signResults.concat(opt_customWorkSignResults);
          }
          signMultiple(signResults);
        }
        else {
          const selectedVersion = getSelectedVersionNumber(jModalWindow);

          const signVersions = function (versions) {
            let signResults = [];
            for (let docId in versions) {
              signResults.push(sign(jModalWindow, docId, versions[docId][3], versions[docId][0], versions[docId][2], true));
            }
            for (let taskId in taskIds) {
              signResults.push(sign(jModalWindow, taskIds[taskId], null, null, taskNames[taskId], true, true, 'T'));
            }
            for (let jobId in jobIds) {
              signResults.push(sign(jModalWindow, jobIds[jobId], null, null, jobNames[jobId], true, true, 'J'));
            }
            if (opt_customWorkSignResults) {
              signResults = signResults.concat(opt_customWorkSignResults);
            }
            signMultiple(signResults);
          };

          switch (selectedVersion) {
          default:
            WA.SRV.request('/EDocument.asmx/GetLastVersionForMultipleDocs', {
              EDocID: documentId,
              OnlyActual: selectedVersion === 'last_actual',
            }, { hideSpinner: true }).done(versions => {
              signVersions(versions);
            }).error(error => {
              jModalWindow.dialog('close');
              $.when(WA.FormControlsInit).then(() => {
                WA.CMP.NTF.InlineHint.hideAll();
              });
              const dialog = new WA.CMP.dialogs.MessageBox({ width: 600 });
              dialog.showError(error);
            });
            break;
          case 'ask':
            WA.SRV.request('/EDocument.asmx/GetLastVersionForMultipleDocs', {
              EDocID: documentId,
              OnlyActual: false,
            }, { hideSpinner: true }).done(versions => {
              let docsWithManyVersions = [];
              for (docId in versions) {
                if (versions[docId][1] > 1) {
                  docsWithManyVersions.push(docId);
                }
              }

              const askFinished = $.Deferred();

                //Запрашиваем версию для всех документов
              if (docsWithManyVersions.length) {

                const getSelectedVersionNumber = function (jDialog) {
                  return jDialog.find('input[type="radio"]:checked').val();
                };

                const buildNextDialog = function () {
                  const docId = docsWithManyVersions.shift();
                  if (!docId) {
                    askFinished.resolve(versions);
                    return;
                  }

                  const dialog = new WA.CMP.dialogs.BaseDialog();
                  dialog.setSpinner();
                  dialog.setTitle(L('VERSION_SELECT'));
                  dialog.width = 600;
                  dialog.isShowOkButton = true;
                  dialog.isShowCancelButton = true;
                  dialog.show();

                  dialog.ok = () => {
                    const version = getSelectedVersionNumber($('#dialog_content_' + dialog.id));
                    versions[docId][0] = version;
                    buildNextDialog();
                  };

                  dialog.cancel = () => {
                      // Пропускаем документ, т.к. версию так и не выбрали.
                    delete versions[docId];
                    buildNextDialog();
                  };

                  WA.SRV.request('/EDocument.asmx/GetVersionListControl', {
                    EDocID: docId,
                    OnlyActual: false,
                  }, { hideSpinner: true }).done(html => {
                    dialog.setHtml(L('SELECT_FROM_EDOC_VERSION_LIST_CAPTION', ('' + versions[docId][2]).escapeHtml()) + '<br/><br/>' + html);
                  });
                };

                buildNextDialog();
              } else {
                askFinished.resolve(versions);
              }

              askFinished.done(versions => {
                signVersions(versions);
              });
            }).error(error => {
              jModalWindow.dialog('close');
              $.when(WA.FormControlsInit).then(() => {
                WA.CMP.NTF.InlineHint.hideAll();
              });
              const dialog = new WA.CMP.dialogs.MessageBox({ width: 600 });
              dialog.showError(error);
            });
            break;
          }
        }
      } else {
        if ((!isSignCustomwork) && (!ObjType)) {
          let versionNumber = getSelectedVersionNumber(jModalWindow);
          // Выполнить проверку, просмотрен ли документ
          runWithCheckReadByUser(jModalWindow, documentId, versionNumber, wrap(function () {
            sign(jModalWindow, documentId, cardTypeCode, versionNumber, '', isMultiple);
          }, jModalWindow));
        } else {
          sign(jModalWindow, documentId, null, null, null, isMultiple, isSignCustomwork, ObjType);
        }
      }
      return false; // Возвращаем false, чтоб окно не закрылось.
    });

    jModalWindow.data('close', () => {
      UnlockDocIfNeed(jModalWindow, documentId, isMultiple);
    });

    jModalWindow.data('disable_ok')(); // не разрешаем никуда нажимать, пока все не прогрузилось.
  };

  /**
  * Показывает контрол запроса пин-кода.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @param {boolean} withAnimation - признак показа анимации.
  */
  function showTokenPinControls(jModalWindow, withAnimation) {
    // Инициализация контрола по запросу пин-кода для токена.
    var jTokenPinMessage = jModalWindow.find('#new_error_container');
    var jTokenPinInput = jModalWindow.find('.token_pin_code');
    // Обернуть сообщение и поле ввода для пин-кода нельзя ввиду особенностей рендера диалога.
    var tokenPinMessageHeight = jTokenPinMessage.parent().height();
    var tokenPinInputHeight = jTokenPinInput.parent().parent().height();

    if (jTokenPinMessage.length > 0 && !jTokenPinMessage.is(':visible')) {
      jTokenPinMessage.parent().show();
      jTokenPinInput.parent().parent().show();

      var pinPadding = 20; // Дополнительный отступ, чтобы не появлялся скролл.
      var newHeight = jModalWindow.height() + tokenPinMessageHeight + tokenPinInputHeight + pinPadding;

      if (withAnimation) {
        jModalWindow.animate({
          height: newHeight
        }, 300, function () {
          $('.token_pin_code').focus();
        });
      } else {
        jModalWindow.height(newHeight);
        $('.token_pin_code').focus();
      }
    }
  }

  /**
  * Скрывыет контрол запроса пин-кода.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @param {boolean} withAnimation - признак показа анимации.
  */
  function hideTokenPinControls(jModalWindow, withAnimation) {
    // Инициализация контрола по запросу пин-кода для токена.
    var jTokenPinMessage = jModalWindow.find('#new_error_container');
    var jTokenPinInput = jModalWindow.find('.token_pin_code');
    // Обернуть сообщение и поле ввода для пин-кода нельзя ввиду особенностей рендера диалога.
    var tokenPinMessageHeight = jTokenPinMessage.parent().height();
    var tokenPinInputHeight = jTokenPinInput.parent().parent().height();

    if ((jTokenPinMessage.length != 0) && (jTokenPinMessage.parent().is(':visible'))) {
      var newHeight = jModalWindow.height() - tokenPinMessageHeight - tokenPinInputHeight;

      if (withAnimation) {
        jModalWindow.animate({
          height: newHeight
        }, 500, function () {
          jTokenPinMessage.parent().hide();
          jTokenPinInput.parent().parent().hide();
          jTokenPinInput.val('');
        });
      } else {
        jModalWindow.height(newHeight);
        jTokenPinMessage.parent().hide();
        jTokenPinInput.parent().parent().hide();
        jTokenPinInput.val('');
      }
    }
  }

  /**
  * Возвращает номер выбранной версии.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @return {number} Номер версии, выбранной пользователем.
  */
  function getSelectedVersionNumber(jModalWindow) {
    return jModalWindow.find('input[type="radio"]:checked').val();
  }

  /**
  * Возвращает признак утверждающей подписи.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  */
  function getIsApproving(jModalWindow) {
    return jModalWindow.find('#sign_approving').is(':checked');
  }

  /**
  * Возвращает признак подписания за замещаемого.
  * @inner
  * @param {object} jModalWindow -модальное окно формы подписания.
  */
  function getIsSubstitute(jModalWindow) {
    return jModalWindow.find('#sign_substitute').is(':checked');
  }

  /**
  * Возвращает выбранный сертификат.
  * @inner
  * @param {object} jModalWindow модальное окно формы подписания.
  * @return {object} Объект с информацией о сертификате {id: <string>, id_base64: <string>, plugin: <string>, plugin_version: <string>, plugin_version_base64: <string>}
  */
  function getSelectedCertificate(jModalWindow) {
    const certInfo = jModalWindow.find('input[name="sign_certificate"]').val().split('###');
    return {
      id: certInfo[2],
      id_base64: certInfo[1],
      plugin: certInfo[0],
      plugin_version: certInfo[3],
      plugin_version_base64: certInfo[4]
    };
  }

  /**
  * Возвращает ИД пользователя, за которого выполняется подписание.
  * @inner
  * @param {object} jModalWindow -модальное окно формы подписания.
  */
  function getSelectedUser(jModalWindow) {
    return $.trim(jModalWindow.find('#hSelID_sign_user').val());
  }

  /**
  * Устанавливает пользователей, за которых можно подписать.
  * @inner
  * @param {object} jModalWindow -модальное окно формы подписания.
  * @param {array<string>} codes - массив кодов пользователей.
  */
  function setAllowedUserCodes(jModalWindow, codes) {
    jModalWindow.find('#hLeadSelID_sign_user').val('SUBS_' + codes.join(';'));
  }

  /**
   *  Получает список замещаемых пользователей, которым доступно подписание.
   *
   * @inner
   * @function getSubstitutedUserCodes
   * @param {Object} jModalWindow -модальное окно формы подписания.
   * @param {number} edocid - ид документа или массив ид документов для множественного подписания
   * @param {boolean} isMultiple - признак множественного подписания
   * @param {Object} verData -  объект, содержащий информацию для каждой версии:
   * verData[verNumber].vis = array[] - массив кодов пользователей, за которых можно подписать визирующей подписью
   * verData[verNumber].app = array[] - массив кодов пользователей, за которых можно подписать утверждающей подписью
   * verData[verNumber].data.canApprovingSign -  возможносит подписания утверждающей подписью
   * verData[verNumber].data.signatures -  подписи
   * @param {number} opt_verNumber - номер версии.
   * @return {Deferred<void>}
   * @see https://api.jquery.com/category/deferred-object/
   */
  function getSubstitutedUserCodes(jModalWindow, edocid, isMultiple, verData, opt_verNumber) {

    var def = $.Deferred();
    var signTypeVal = { vis: false, app: true };
    var signType = 'vis';
    if (getIsApproving(jModalWindow)) {
      signType = 'app';
    }

    if (isMultiple) {
      CallService('/EDocument.asmx/GetSubstitutedUserCodesForMultipleDocuments', { EDocID: edocid, IsApprovingSignType: signTypeVal[signType] }, function (res) {
        res = $.trim(res.substr(5));
        def.resolve((res === '' ? [] : res.split(';')));
      }, function () {
        def.reject();
      });
      return def;
    }

    if (verData[opt_verNumber][signType] !== 'loading') {
      def.resolve();
    } else {
      // Грузим список пользователей, за которых мы можем подписать эту версию.
      CallService('/EDocument.asmx/GetSubstitutedUserCodes', { EDocID: edocid, VersionNum: opt_verNumber, IsApprovingSignType: signTypeVal[signType] }, function (res) {
        res = $.trim(res.substr(5)); // сервис возвращает в убогом формате
        verData[opt_verNumber][signType] = (res === '' ? [] : res.split(';'));
        def.resolve();
      }, function () {
        def.reject();
      });
    }

    return def;
  }

  /**
  *  Событие выбора версии.
  * @inner
  * @param {object} jModalWindow -модальное окно формы подписания.
  * @param {number} edocid - ид документа или массив ид документов для множественного подписания
  * @param {boolean} isMultiple - признак множественного подписания
  * @param {object} verData -  объект, содержащий информацию для каждой версии:
      verData[verNumber].vis = array[] - массив кодов пользователей, за которых можно подписать визирующей подписью
      verData[verNumber].app = array[] - массив кодов пользователей, за которых можно подписать утверждающей подписью
      verData[verNumber].data.canApprovingSign -  возможносит подписания утверждающей подписью
      verData[verNumber].data.signatures -  подписи
  * @param {number} verNumber - номер версии.
  * @param {object} addInfo - информация о текущем пользователем и виде документа.
  * @return {number} - номер версии
  */
  function verSelect(jModalWindow, edocid, isMultiple, certData, verData, verNumber, addInfo) {
    if (isMultiple) {
      if (getIsSubstitute(jModalWindow)) {
        getSubstitutedUserCodes(jModalWindow, edocid, isMultiple, verData);
      }
      return verNumber;
    }

    pleaseWaitMessage.show();
    if (!verData.hasOwnProperty(verNumber)) {
      addInfo.userID = addInfo.userID || 'loading';
      addInfo.docKind = addInfo.docKind || 'loading';

      verData[verNumber] = { vis: 'loading', app: 'loading', data: 'loading' }; // в начале все "loading", потом заменятся на норм. данные, когда они подгрузятся с сервера.

      if (getIsSubstitute(jModalWindow)) {
        getSubstitutedUserCodes(jModalWindow, edocid, isMultiple, verData, verNumber);
      }

      // Грузим информацию о состоянии подписей к версии.
      CallService('/EDocument.asmx/GetSignState', { EDocID: edocid, VersionNum: verNumber }, function (res) {
        if (res.Error) {
          verData[verNumber].error = res.Error;
        } else {
          addInfo.userID = res.UserID;
          addInfo.docKind = res.Kind;
          verData[verNumber].data = { canApprovingSign: res.CanApprovingSign, signatures: res.SignsInfo };
        }
        checkConditions(jModalWindow, certData, verData, addInfo);
        pleaseWaitMessage.hide();
      });
    } else {
      checkConditions(jModalWindow, certData, verData, addInfo);
      pleaseWaitMessage.hide();
    }
  }

  /**
  *  Событие выбора сертификата.
  * @inner
  * @param {object} jModalWindow -модальное окно формы подписания.
  * @param {object} certData - объект с информацией о сертификатах и их валидности.
  * @param {object} verData -  объект, содержащий информацию для каждой версии: 
      verData[verNumber].vis = array[] - массив кодов пользователей, за которых можно подписать визирующей подписью
      verData[verNumber].app = array[] - массив кодов пользователей, за которых можно подписать утверждающей подписью
      verData[verNumber].data.canApprovingSign -  возможносит подписания утверждающей подписью
      verData[verNumber].data.signatures -  подписи      
  * @param {object} addInfo - информация о текущем пользователем и виде документа.
  */
  function certSelect(jModalWindow, certData, verData, addInfo) {
    hideTokenPinControls(jModalWindow, false);
    pleaseWaitMessage.show();
    var curCert = getSelectedCertificate(jModalWindow);
    if (!certData.hasOwnProperty(curCert.sid)) {
      certData[curCert.id] = 'loading';
      CallService('/Certificates.asmx/IsCertificateValid', { CertificateID: curCert.id_base64 }, function (res) {
        certData[curCert.id] = { valid: res.Result };
        checkConditions(jModalWindow, certData, verData, addInfo);
        pleaseWaitMessage.hide();
      });
    }
    else {
      checkConditions(jModalWindow, certData, verData, addInfo);
      pleaseWaitMessage.hide();
    }
  }

  /**
  *  Проверка возможности подписания.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @param {object} certData - объект с информацией о сертификатах и их валидности.
  * @param {object} verData -  объект, содержащий информацию для каждой версии: 
       verData[verNumber].vis = array[] - массив кодов пользователей, за которых можно подписать визирующей подписью
       verData[verNumber].app = array[] - массив кодов пользователей, за которых можно подписать утверждающей подписью
       verData[verNumber].data.canApprovingSign -  возможносит подписания утверждающей подписью
       verData[verNumber].data.signatures -  подписи.
  * @param {object} addInfo - информация о текущем пользователем и виде документа.
  */
  function checkConditions(jModalWindow, certData, verData, addInfo) {

    var verNumber = getSelectedVersionNumber(jModalWindow);
    var ver = verData[verNumber];
    var error = null;
    var isApproving = getIsApproving(jModalWindow);
    var isSubstitute = getIsSubstitute(jModalWindow);
    var curCert = getSelectedCertificate(jModalWindow);
    if (ver) {
      try {
        if (ver.error) // если произошла ошибка при получении данных с сервера.
          throw new Error(ver.error);
        if (isSubstitute) {
          // Проверка наличия пользователей, за которых можно подписать утверждающей подписью.
          if (isApproving) {
            if (ver.app == 'loading')
              throw new Error('loading');
            if (!ver.app.length)
              throw new Error('w#' + L('YOU_CANT_SIGN_THIS_DOCUMENT_IN_THE_NAME_OF_SUBSTITUTED_USER_APPROV'));
            setAllowedUserCodes(jModalWindow, ver.app);
          }
          // Проверка наличия пользователей, за которых можно подписать визирующей подписью.
          if (!isApproving) {
            if (ver.vis == 'loading')
              throw new Error('loading');
            if (!ver.vis.length)
              throw new Error('w#' + L('YOU_CANT_SIGN_THIS_DOCUMENT_IN_THE_NAME_OF_SUBSTITUTED_USER'));
            setAllowedUserCodes(jModalWindow, ver.vis);
          }
        }
        if (ver.data != 'loading' && addInfo.docKind != 'loading') {
          // Проверка возможности подписания утверждающей подписью.
          if (isApproving && !ver.data.canApprovingSign) {
            throw new Error('w#' + L('HAVENT_RIGHTS_FOR_APPR_SIGN', addInfo.docKind.Name));
          }
          // Проверка на то, что версия уже подписана тем же пользователем и сертификатом.
          let signErr = 'w#';
          let curUserID;
          let curUserName;
          if (isSubstitute) {
            // Проверяем подписи от имени другого пользователя.
            curUserID = $.trim(jModalWindow.find('#hSelID_sign_user').val());
            // Получаем отображаемое имя замещаемого пользователя.
            let selectedSubstituteUser = jModalWindow.find('#sign_user').data('ReferenceSelectInstance').selectedItems[0];
            if (selectedSubstituteUser) {
              curUserName = $.trim(selectedSubstituteUser.textContent);
            }
          } else {
            // Проверяем подписи текущего пользователя.
            curUserID = addInfo.userID;
          }
          $.each(ver.data.signatures, function () {
            var sign = this;
            if (isApproving === (sign.SignatureType === '2') &&
              sign.ByUserID == curUserID) {
              if (sign.PluginName === curCert.plugin &&
                sign.CertificateID === curCert.id_base64) {

                if (isApproving && !isSubstitute)
                  signErr += L('EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED', verNumber);
                else if (!isApproving && !isSubstitute)
                  signErr += L('EDOC_VERSION_ALREDY_SIGNED', verNumber);
                else if (isApproving && isSubstitute)
                  signErr += L('EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER', verNumber, curUserName);
                else if (!isApproving && isSubstitute)
                  signErr += L('EDOC_VERSION_ALREDY_SIGNED_BY_USER', verNumber, curUserName);
              }
              else {
                //Если подписана текущим пользователем, но другим сертификатом.
                signErr = "info#" + L('INFO_EDOC_VERSION_ALREDY_SIGNED', verNumber);
              }
              return false;
            }
          });
          if (signErr != 'w#') throw new Error(signErr);
        } else {
          throw new Error('loading');
        }
      } catch (ex) {
        error = ex.message;
      }
    }

    var cert = certData[curCert.id];
    if (!error && cert && cert != 'loading') {
      if (!cert.valid) {
        error = L('CERTIFICATE_WITH_ID_IS_NOT_VALID', curCert.id);
      }
    }

    //Очищаем ошибку и предупреждение, чтобы установить актуальное
    jModalWindow.data('info')(null);
    jModalWindow.data('warning')(null);
    jModalWindow.data('error')(null);

    if (error !== null) {
      let disableOk = true;
      if (error != 'loading') {
        if (error.indexOf('w#') == 0) {
          jModalWindow.data('warning')(error.substr(2));
        } else if (error.indexOf('info#') == 0) {
          jModalWindow.data('info')(error.substring(5));
          disableOk = false;
        } else {
          jModalWindow.data('error')(error);
        }
      }
      if (disableOk) {
        jModalWindow.data('disable_ok')();
      } else {
        jModalWindow.data('enable_ok')();
      }
      return false;
    } else {      
      jModalWindow.data('enable_ok')();
      return true;
    }
  }

  /**
  *  Обновление иконки наличия подписи.
  * @inner
  * @param {number} docID - ИД документа.
  * @param {boolean} isApproving - признак утверждающей подписи.
  */
  function updateSignIco(docID, isApproving) {
    var item = $('div#' + docID);
    log.info('DOCUMENT_SIGNING', 'Updating icon for document #' + docID);

    if (item.length) {
      var signatureIcon = (item.find('.sign_ico'));
      if (signatureIcon.length == 0 || (isApproving && signatureIcon.find('use').attr('xlink:href') != '#signRed-16')) {
        signatureIcon.remove();
        var signIco = '<svg class=" h16 object-list-item__addicon object-list-item__addicon_type_signature sign_ico">' +
          '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#sign' + (isApproving ? 'Red' : 'Yellow') + '-16" alt="S" title="" />' +
          '</svg>';
        item.find('.object-list-item__column_type_icon').append(signIco);
      }
    }
  }

  /**
  *  Вызывается, если подписание прошло успешно.
  * @inner
  * @param {object} jModalWindow модальное окно формы подписания.
  * @param {number} docID ИД документа.     
  * @param {boolean} isMultiple TRUE если множественное подписание, иначе - FALSE.
  * @param {boolean} isSignCustomwork TRUE если подписание ЗЗУ, иначе - FALSE.
  * @param {string} ObjType тип объекта.
  */
  function success(jModalWindow, docID, isMultiple, isSignCustomwork, ObjType) {
    const isApproving = getIsApproving(jModalWindow);

    if (!isMultiple) {
      jModalWindow.dialog('close');
      let successMessageCode = 'EDOCUMENT_SIGN_SUCCESS';
      if (isSignCustomwork) {
        successMessageCode = (ObjType === 'T' ? 'TASK_SIGN_SUCCESS' : 'JOB_SIGN_SUCCESS');
      }
      ShowTopSpinnerResult(L(successMessageCode), 3000);
    }

    if (WA.getLocation() === 'doc') {
      if (GetParamInURL('view').toLowerCase() === 'showverlist') {
        setTimeout(function () { ReloadVersionList(); }, 500);
      } else {
        window.location.reload();
      }
    }

    // Обновить иконку, чтобы отобразить результат подписания.
    if ((!isSignCustomwork) && (!ObjType)) {
      updateSignIco(docID, getIsApproving(jModalWindow));

      if (isMultiple) {
        updateSignIco(docID, isApproving);
      }
    }
  }

  /**
  *  Вызывается, если произошла ошибка при подписании.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @param {string} err - текст ошибки.
  */
  function fail(jModalWindow, err) {
    if (jModalWindow.data('error')) {
      jModalWindow.data('error')(err);
      jModalWindow.data('enable_ok')();
    } else {
      var d = new WA.CMP.dialogs.MessageBox();
      d.showError(err);
    }
  }

  /**
  *  Запуск подписания с проверкой, посмотрел ли пользователь версию документа.
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @param {number} docID - ИД документа. 
  * @param {number} versionNum - Номер версии документа. 
  * @param {object} callback - функция . 
  */
  function runWithCheckReadByUser(jModalWindow, docId, versionNum, callback) {
    // Если диалог подтверждения был уже показан, то не надо показывать его еще раз
    var confirmed = jModalWindow.data('signConfirmed');
    if (confirmed) {
      callback();
    } else {
      WA.SRV.call('/EDocument.asmx/CheckReadByUserState', { EDocID: docId, VersionNum: versionNum }).done(function (res) {
        if (res) {
          callback();
        } else {
          // Если последние изменения не просмотрены, показать диалог подтверждения
          confirmSignDialog(function () {
            jModalWindow.data('signConfirmed', true);
            callback();
          });
        }
      }).fail(function () {
        callback();
      });
    }
  }

  /**
  * Сохранение типа подписи в профиле пользователя
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  */
  function saveDialogParams(jModalWindow) {
    WA.SRV.request('Session.asmx/SetUserProfileSettings', {
      ParamName: 'DefaultSignType',
      ParamValue: getIsApproving(jModalWindow) ? 'approve' : '',
    }, { hideSpinner: true });
  }

  /**
  * Сохранить информацию о сертификате для подписания ЗЗУ
  * @innner
  * @function saveSignCustomworkInfo
  * @param {certId} ид сертификата
  */
  function saveSignCustomworkInfo(certId) {
    //Этот параметр используется на сервере, поэтому не надо записывать его в json
    WA.SRV.request('/Session.asmx/SetUserProfileSettings', {
      ParamName: 'CertificateIDForCustomworkSign',
      ParamValue: certId,
    }, { hideSpinner: true });
  }

  /**
  * Добавление в текст ошибки наименования документа и ИД документа
  * @inner
  * @param {string} error текст ошибки.
  * @param {string} docName наименование документа.
  * @param {number} docId ИД документа.
  * @param {string} objtype тип объекта (для ЗЗУ).
  */
  function getErrorWithDocName(error, docName, docId, objtype) {
    let objLink = (new WA.Link(docId, OBJECT_TYPE.EDOCUMENT)).toURL().asString();
    let objTypeName = L('DOCUMENT');
    if (objtype) {
      if (objtype === 'J') {
        objLink = (new WA.Link(docId, OBJECT_TYPE.JOB)).toURL().asString();
        objTypeName = L('JOB');
      } else {
        objLink = (new WA.Link(docId, OBJECT_TYPE.TASK)).toURL().asString();
        objTypeName = L('TASK');
      }
    }
    if (!error) {
      //Сюда может зайти например если вынули токен при подписании и нажали Отмена в окне с токеном
      error = L('CERTIFICATE_FOR_SIGNING_OBJECT_IS_NOT_SPECIFIED_OR_SPECIFIED_INCORRECTLY');
    }

    return `<li> ${objTypeName} "<a href="${objLink}" target="_blank">${docName}</a>": ${error}</li>`;
  }

  /**
  * Вывод диалога подтверждения подписания непрочитанной версии документа
  * @inner
  * @param {object} okAction - функция вызывающаяся при нажатии Ok .
  */
  function confirmSignDialog(okAction) {
    var confirmDialog = new WA.CMP.dialogs.MessageBox();
    confirmDialog.yesNoButtons(okAction);

    var mainText = L('EDOC_CONTINUE_SIGNING');
    var additionalText = L('EDOC_VERSION_IS_NOT_READ');
    var title = L('CONFIRMATION');
    var icon = 'info';
    confirmDialog.show(mainText, additionalText, title, icon);
  }

  /**
  * Декоратор для функций.
  * @inner
  * @param {object} func - функция для декорирования.
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @return {boolean} Если в функции произошла ошибка (брошено исключение), то вызывает fail и возвращает false. Иначе возвращает true.
  */
  function wrap(func, jModalWindow) {
    return function () {
      try {
        func.apply(this, arguments);
        return true;
      } catch (ex) {
        var msg = ex.message;
        if (msg.indexOf('E_CANT_LOAD_PLUGIN') != -1) {
          msg = L('SIGN_PLUGIN_NOT_FOUND');
        }
        fail(jModalWindow, msg);
        return false;
      }
    };
  }

  /**
   * Подписание версии документа.
   *
   * @inner
   * @function sign
   * @param {Object} jModalWindow модальное окно формы подписания.
   * @param {number} documentId ИД документа.
   * @param {string} cardTypeCode тип карточки документа
   * @param {number} versionNum номер подписываемой версии.
   * @param {string} docName наименование документа.
   * @param {boolean} isMultiple TRUE если множественное подписание, иначе FAlSE.
   * @param {boolean} isSignCustomwork TRUE если подписание объекта ЗЗУ, иначе FAlSE.
   * @param {string} objtype тип объекта (для ЗЗУ)
   * @return {Deferred<void>}
   * @see https://api.jquery.com/category/deferred-object/
   */
  function sign(jModalWindow, documentId, cardTypeCode, versionNum, docName, isMultiple, isSignCustomwork, objtype) {
    docName = ('' + docName).escapeHtml();

    const d = $.Deferred();
    // Дизейблим ок, чтобы пользователь не тыкал куда попало.
    jModalWindow.data('disable_ok')();
    if (isMultiple) {
      if (getIsSubstitute(jModalWindow) && !getSelectedUser(jModalWindow)) {
        return d.reject(L('VALUE_OF_REQUIRED_REQUISITE_USER_MUST_BE_SPECIFIED'));
      }
    } else {
      if (getIsSubstitute(jModalWindow) && !getSelectedUser(jModalWindow)) {
        throw new Error((L('VALUE_OF_REQUIRED_REQUISITE_USER_MUST_BE_SPECIFIED')));
      }
    }

    // Версия не передана или её номер не корректный.
    if ((+versionNum < 1) && (!isSignCustomwork) && (!objtype)) {
      if (isMultiple) {
        return d.reject(getErrorWithDocName(L('ERR_NO_VERSIONS_AVAILABLE_WITHOUT_DOCUMENT_NAME'), docName, documentId, objtype));
      } else {
        throw new Error(format(L('ERR_NO_VERSIONS_AVAILABLE'), docName));
      }
    }

    const cert = getSelectedCertificate(jModalWindow);
    Core.agent.getPlugin('CryptographyPlugin').done(plugin => {
      const onSignCallback = function (res) {
        if (res.success) {
          success(jModalWindow, documentId, isMultiple, isSignCustomwork, objtype);
          log.info('DOCUMENT_SIGNING', 'Signing success for document ' + docName);
          d.resolve();
        } else {
          if (!!res.message && (res.result === 'ERR_PIN_REQUIRED')) {
            showTokenPinControls(jModalWindow, true);
            jModalWindow.data('enable_ok')();
            return;
          }
          //Почистить запись в профиле
          WA.cache.serverCache.setItem('CertificateIDForCustomworkSign', '');

          log.info('DOCUMENT_SIGNING', 'Signing failed for document ' + docName);
          if (!res.message) {
            return; //например, агент отвалился
          }
          d.reject(getErrorWithDocName(res.message.fromISBuilderToNormal(), docName, documentId, objtype));

          if (!isMultiple) {
            if (!!res.message && res.message !== 'CONNECTION_NOT_AVAILABLE') {
              fail(jModalWindow, L(res.message));
            }
          }
        }
        if (!isMultiple) {
          UnlockDocIfNeed(jModalWindow, documentId, isMultiple);
        }
      };
      if ((isSignCustomwork) || (objtype)) {
        //Сохранить информацию в профиль о сертификате
        saveSignCustomworkInfo(cert.id);

        if (objtype === 'J') {
          WebAccess.agent.edms.signJob(
           documentId,
           cert.id_base64,
           cert.plugin,
           null,
           null,
           null,
           null,
           onSignCallback,
           cert.plugin_version_base64,
           jModalWindow.find('.token_pin_code').val());
        } else {
          WebAccess.agent.edms.signTask(
           documentId,
           cert.id_base64,
           cert.plugin,
           null,
           null,
           null,
           null,
           onSignCallback,
           cert.plugin_version_base64,
           jModalWindow.find('.token_pin_code').val());
        }
      }
      else {
        const edocVersion = getSelectedVersionNumber(jModalWindow);
        WA.SRV.request('/EDocument.asmx/GetAdditionalInfo', { EdocId: documentId }, { hideSpinner: true, sync: true }).done(additionalInfo => {
          WA.SRV.document.sign(documentId,
            cardTypeCode,
            versionNum || edocVersion,
            cert.id_base64,
            cert.plugin,
            jModalWindow.find('#sign_comment').val(),
            getIsApproving(jModalWindow),
            getIsSubstitute(jModalWindow),
            getSelectedUser(jModalWindow),
            onSignCallback,
            additionalInfo,
            cert.plugin_version,
            jModalWindow.find('.token_pin_code').val()).fail((message) => {
              // jModalWindow.parentNode проверяет, был ли удален DOM-элемент
              if (jModalWindow.parentNode) {
                jModalWindow.data('error')(message);
              }
            });
        });
      }
    }).fail(needShowError => {
      if (needShowError) {
        ShowError(L('ERR_SIGNING_UNSUPPORTED'));
      }
    });

    return d.promise();
  }

  /**
  * Разблокировка документа 
  * @inner
  * @param {object} jModalWindow - модальное окно формы подписания.
  * @param {number|Array} edocid - ИД документа или массив из ИД документов.
  * @param {boolean} isMultiple - признак множественного подписания.
  */
  function UnlockDocIfNeed(jModalWindow, edocid, isMultiple) {
    if (jModalWindow.find('#was_locked').val() == 'True') {
      var method = isMultiple ? 'MultipleDocsUnlock' : 'DocUnlock';
      CallService('/EDocument.asmx/' + method, { EDocID: edocid });
    }
  }

})(window);